import script from "./main.vue?vue&type=script&lang=ts&setup=true"
export * from "./main.vue?vue&type=script&lang=ts&setup=true"

import "./main.vue?vue&type=style&index=0&id=766d4905&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-766d4905"]])

export default __exports__